import { MediaType } from "constants/enums";
import { DirectUploadMedia } from "libs/directUpload";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { LightBoxGallery } from "ui";

import { DriverCertificateBlock } from "../DriverCertificateBlock";
import { DriverCertificatesProps } from "./DriverCertificates.types";

const renderTextOrPlaceholder = (text?: string, placeholder = "-") => {
  return text ?? placeholder;
};

const DriverCertificates = ({
  driverDetails,
  className
}: DriverCertificatesProps) => {
  const { t } = useTranslation();

  const [openedImageIndex, setOpenedImageIndex] = useState<number>();

  const allImages = useMemo(() => {
    return [
      ...(driverDetails.driverLicense.images ?? []),
      ...(driverDetails.insurance.images ?? []),
      ...(driverDetails.idLicense.images ?? []),
      ...(driverDetails.vehicle.images ?? [])
    ];
  }, [driverDetails]);

  const handleImageClick = (image: DirectUploadMedia) => {
    if (image.mediaType !== MediaType.DOCUMENT) {
      setOpenedImageIndex(allImages.findIndex((item) => item.id === image.id));
    }
  };

  return (
    <div className={className} data-testid="driverInfo--certificates">
      <DriverCertificateBlock
        header={[
          {
            title: t("Driver License"),
            subtitle: renderTextOrPlaceholder(
              driverDetails.driverLicense.reference
            )
          }
        ]}
        images={driverDetails.driverLicense.images}
        onImageClick={handleImageClick}
      />
      <DriverCertificateBlock
        header={[
          {
            title: t("Insurance"),
            subtitle: renderTextOrPlaceholder(driverDetails.insurance.reference)
          }
        ]}
        images={driverDetails.insurance.images}
        onImageClick={handleImageClick}
      />
      <DriverCertificateBlock
        header={[
          {
            title: t("ID"),
            subtitle: renderTextOrPlaceholder(driverDetails.idLicense.reference)
          }
        ]}
        images={driverDetails.idLicense.images}
        onImageClick={handleImageClick}
      />
      <DriverCertificateBlock
        header={[
          {
            title: t("Vehicle Type"),
            subtitle: renderTextOrPlaceholder(driverDetails.vehicle.type)
          },
          {
            title: t("Plate Number"),
            subtitle: renderTextOrPlaceholder(driverDetails.vehicle.reference)
          }
        ]}
        images={driverDetails.vehicle.images}
        onImageClick={handleImageClick}
      />

      <LightBoxGallery
        mediaList={allImages}
        openedImageIndex={openedImageIndex}
        setOpenedImageIndex={setOpenedImageIndex}
      />
    </div>
  );
};

export default DriverCertificates;
